import { AuthSessionApiDto, authTokensToAuthSession, toAuthSession } from "@/model/AuthSession";
import { AuthTokens } from "@/model/AuthTokens";
import ClinicalProtocolType from "@/model/ClinicalProtocolType";
import { atom, getDefaultStore, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { authMode } from "./authMode";

// This persists using localStorage internally
const authSessionApiDtoAtom = atomWithStorage<AuthSessionApiDto | null>(
  "session",
  null,
  undefined,
  { getOnInit: true }
);
const authTokensAtom = atomWithStorage<AuthTokens | null>("tokens", null, undefined, {
  getOnInit: true,
});
const authSessionAtom = atom((get) => {
  if (authMode === "bearer") {
    const tokens = get(authTokensAtom);
    return tokens ? authTokensToAuthSession(tokens) : null;
  }
  const dto = get(authSessionApiDtoAtom);
  return dto ? toAuthSession(dto) : null;
});
export const authSession = () => getDefaultStore().get(authSessionAtom);
export const setAuthSession = (session: AuthSessionApiDto) =>
  getDefaultStore().set(authSessionApiDtoAtom, session);
export const authTokens = () => getDefaultStore().get(authTokensAtom);
export const setAuthTokens = (tokens: AuthTokens) => getDefaultStore().set(authTokensAtom, tokens);
export const clearAuthSession = () => {
  getDefaultStore().set(authSessionApiDtoAtom, null);
  getDefaultStore().set(authTokensAtom, null);
};
export const useAuthSessionAtom = () => useAtom(authSessionAtom);

const patientPopulationAtom = atomWithStorage<ClinicalProtocolType>(
  "patientPopulation",
  "diabetes",
  undefined,
  { getOnInit: true }
);
export const usePatientPopulationAtom = () => useAtom(patientPopulationAtom);
